// LeaderboardPanel — Phase 2 / Step C-3.3 Pass 1 shim. See
// shared/widgets/scenario_os/LeaderboardPanel.jsx for the canonical
// implementation. The shared widget takes `gamificationAPI` as a prop;
// learner-app callers were already passing `domain`, `scope`, etc. so
// the only adapter needed is forwarding the API client. We bind the
// learner-app singleton here so existing usages keep working untouched.
import React from 'react';
import { gamificationAPI } from '../../services/api';
import LeaderboardPanelShared from '../../../../shared/widgets/scenario_os/LeaderboardPanel.jsx';

export default function LeaderboardPanel(props) {
  return <LeaderboardPanelShared gamificationAPI={gamificationAPI} {...props} />;
}
